import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { mapDto } from '@shared/operators';
import { School, SchoolDto } from '../models';

@Injectable({
    providedIn: 'root',
})
export class HttpService {
    private httpClient = inject(HttpClient);

    getSchool(id: string): Observable<School> {
        return this.httpClient.get<SchoolDto>(`schools/${id}`).pipe(mapDto((response) => new School(response)));
    }

    getContactEmail(): Observable<string> {
        return this.httpClient.get<{ email: string }>('contact-email').pipe(mapDto((response) => response.email));
    }
}
